import React, { FC, ReactElement, ReactNode } from 'react';

export interface CollapsableTargetRenderProps {
  toggle: () => void;
  isCollapsed: boolean;
  collapseId: number;
  name: string;
}

interface CollapsableTargetProps { children?: (renderProps: CollapsableTargetRenderProps) => ReactElement}

/* istanbul ignore next */
export const Target: FC<CollapsableTargetProps> & { type: Symbol } = () => null;
Target.type = Symbol('Collapsable.Target');

/* istanbul ignore next */
export const Content = ({ children }: {
  children?: ReactNode | (() => ReactNode);
}) => <>{children}</>;
Content.type = Symbol('Collapsable.Footer');
